export type Order = 'asc' | 'desc'

/**
 * @function desc
 * This function returns if the order is descending or ascending
 * @param a
 * @param b
 * @param orderBy
 * @returns Number with the validation is descending or ascending
 */
export function desc<T>(a: T, b: T, orderBy: keyof T) {
  const bOrderBy =
    typeof b[orderBy] === 'string'
      ? (b[orderBy] as any).toUpperCase()
      : b[orderBy]
  const aOrderBy =
    typeof a[orderBy] === 'string'
      ? (a[orderBy] as any).toUpperCase()
      : a[orderBy]
  if (bOrderBy < aOrderBy) {
    return -1
  }
  if (bOrderBy > aOrderBy) {
    return 1
  }
  return 0
}

/**
 * @function stableSort
 * This function orders the array values
 * @param array
 * @param cmp
 * @returns Array with the values order
 */
export function stableSort<T>(array: T[], cmp: (a: T, b: T) => number) {
  const stabilizedThis =
    array?.map((el, index) => [el, index] as [T, number]) || []
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis?.map((el) => el[0])
}
